import { InvoiceStatus } from "../models/invoice";

export const DEFAULT_PAGE_SIZE = 20;

export const ENV = {
  getTinyApiKey: () => window._env_.REACT_APP_TINY_API_KEY,
  getNodeEnv: () => window._env_.NODE_ENV,
  getApiEndPoint: () => window._env_.REACT_APP_PASSPORT_END_POINT,
  getPassportClientId: () => window._env_.REACT_APP_PASSPORT_CLIENT_ID,
  getPassportClientSecret: () => window._env_.REACT_APP_PASSPORT_CLIENT_SECRET,
  getPaymentUrl: () => window._env_.REACT_APP_PAYMENT_URL,
  getHostAppUrl: () => window._env_.REACT_APP_URL,
  getAppName: () => window._env_.REACT_APP_NAME,
};

export const LOCALSTORAGE_FILTER_DATA_KEY = {
  year: "filter:year",
  category: "filter:category",
  customer: "filter:customer",
  priority: "filter:priority",
  user: "filter:user",
  industry: "filter:industry",
  projectManager: "filter:project_manager",
  status: "filter:status",
  type: "filter:type",
};

export const MAINTENANCE_STATUS_COLOR: Record<string, string> = {
  "On Going": "#62D88F",
  Expired: "#F44336",
  Cancelled: "#FAAD14",
  "3 Months": "#FAAD14",
  "2 Months": "#FAAD14",
  "1 Month": "#FAAD14",
  "15 Days": "#FAAD14",
  "7 Days": "#FAAD14",
  "3 Days": "#FAAD14",
  "1 Day": "#FAAD14",
};

export const DOMAIN_STATUS_COLOR: Record<string, string> = {
  "On Going": "#62D88F",
  Expired: "#F44336",
  Cancelled: "#FAAD14",
  "3 Months": "#FAAD14",
  "2 Months": "#FAAD14",
  "1 Month": "#FAAD14",
  "15 Days": "#FAAD14",
  "7 Days": "#FAAD14",
  "3 Days": "#FAAD14",
  "1 Day": "#FAAD14",
};

export const INVOICE_STATUS_COLOR: Record<InvoiceStatus, string> = {
  "Waiting For Approval": "#FAAD14",
  Approved: "#0078F0",
  Paid: "#62D88F",
  Due: "#F44336",
  Sent: "#40A9FF",
  Rejected: "#F44336",
  "Waiting For Confirmation": "#262626",
  "Rejected Confirmation": "#F44336",
  Expired: "#F44336",
};

export const LEAD_STATUS_COLOR: Record<string, string> = {
  PROSPECT: "#0078F0",
  QUALIFIED_OPPORTUNITY: "#40A9FF",
  SOLUTION_FIT: "#40A9FF",
  VENDOR_OF_CHOICE: "#40A9FF",
  TERMS_AGREED: "#40A9FF",
  CLOSED_WON: "#62D88F",
  CLOSED_LOST: "#F44336",
};

export const INBOX_STATUS_COLOR: Record<string, string> = {
  OPEN: "#FAAD14",
  SPAM: "#808080",
  POTENTIAL: "#0078F0",
  MOVED_TO_LEADS: "#62D88F",
};

export const MAINTENANCE_CANCEL_ID = 2;
export const DOMAIN_CANCEL_ID = 23;

export enum LEAD_TABS {
  CLIENT = "1",
  LEAD = "2",
}


